<template>
  <section>
    <div class="container cont checkout-step checkout-step--clean">
      <form class="checkout-step__form checkout-step__form--wide" method="post" @submit.prevent="continueSale()">
        <div class="checkout-step__intro">
          <small class="form-text text-muted checkout-step__eyebrow">Paso 2 de 4</small>
          <h2 class="text-justify va-h6 checkout-step__title"><strong>Datos del comprador</strong></h2>
          <small class="form-text text-muted checkout-step__hint">Usa un solo correo de compra y deja cada acceso listo para validar.</small>
        </div>

        <div class="checkout-form-grid">
          <div class="checkout-field checkout-field--full" @keyup="getCustomer()">
            <label class="checkout-label" for="guest-email">Correo de compra</label>
            <input id="guest-email" class="form-control checkout-input" type="email" v-model="email" name="email" placeholder="tu@email.com" required="">
          </div>

          <template v-if="require_account">
            <div class="checkout-field">
              <label class="checkout-label" for="guest-phone">Teléfono de contacto</label>
              <input id="guest-phone" class="form-control checkout-input" type="text" v-model="phone" name="phone" placeholder="0999999999" required="">
            </div>

            <div class="checkout-field">
              <label class="checkout-label" for="guest-address">Dirección de facturación</label>
              <input id="guest-address" class="form-control checkout-input" type="text" v-model="address" name="address" placeholder="Dirección de domicilio" required="">
            </div>

            <div class="checkout-field checkout-field--full">
              <label class="checkout-label" for="guest-password">Contraseña de acceso</label>
              <input id="guest-password" class="form-control checkout-input" type="password" v-model="password" name="password" placeholder="Crea una contraseña para revisar tus tickets rápido" required="">
            </div>
          </template>
        </div>

        <div v-if="require_account" class="form-check checkout-check">
          <input class="form-check-input" type="checkbox" id="checkout-terms" required="" name="option1" value="something">
          <label class="form-check-label text-muted" for="checkout-terms">Al continuar aceptas los términos y condiciones.</label>
        </div>

        <div v-if="userSearched" class="checkout-step__section">
          <h2 class="text-justify checkout-step__section-title"><strong>Datos de acceso</strong></h2>
          <small class="form-text text-muted checkout-step__section-text">Completa los nombres de cada acceso y mantén la orden clara antes de continuar.</small>

          <div class="checkout-guest-grid">
            <article class="checkout-guest-card" v-for="(product, index) in ticketsTable" :key="index" :style="{ animationDelay: `${index * 60}ms` }">
              <div class="checkout-guest-card__header">
                <span class="checkout-guest-card__eyebrow">Acceso {{ index + 1 }}</span>
                <strong class="checkout-guest-card__title">{{ product.name }}</strong>
                <span v-if="product.seat_assigned" class="checkout-guest-card__meta">Asiento {{ product.seat_name }}</span>
              </div>

              <div class="checkout-form-grid checkout-form-grid--compact">
                <div class="checkout-field">
                  <label class="checkout-label">Nombres</label>
                  <input class="form-control checkout-input" v-model="ticketsTable[index].first_name" type="text" name="first_name" placeholder="Nombre del participante" required="">
                </div>

                <div class="checkout-field">
                  <label class="checkout-label">Apellidos</label>
                  <input class="form-control checkout-input" v-model="ticketsTable[index].last_name" type="text" name="last_name" placeholder="Apellido del participante" required="">
                </div>

                <div class="checkout-field checkout-field--full" v-if="event.id==13">
                  <label class="checkout-label">Instagram</label>
                  <input class="form-control checkout-input" v-model="ticketsTable[index].ig" type="text" name="instagram" placeholder="Usuario de Instagram" required="">
                </div>

                <div class="checkout-field checkout-field--full" v-if="event.id==51">
                  <label class="checkout-label">Documento</label>
                  <input class="form-control checkout-input" v-model="ticketsTable[index].cc" type="text" name="document" placeholder="Número de cédula o pasaporte" required="">
                </div>

                <div class="checkout-field checkout-field--full" v-if="event.id==8">
                  <label class="checkout-label">Edad</label>
                  <input class="form-control checkout-input" v-model="ticketsTable[index].age" type="text" name="age" placeholder="Edad" required="">
                </div>

                <div class="checkout-field checkout-field--full" v-if="event.id==14">
                  <label class="checkout-label">Instagram</label>
                  <input class="form-control checkout-input" v-model="ticketsTable[index].ig" type="text" name="instagram14" placeholder="Usuario de Instagram" required="">
                </div>

                <div class="checkout-field checkout-field--full" v-if="event.id==181 && (product.product=='11481' || product.product=='11482' || product.product=='586' || product.product=='587' || product.product=='588' || product.product=='589' || product.product=='590' || product.product=='591' || product.product=='592' || product.product=='593' || product.product=='594' || product.product=='595' || product.product=='596' || product.product=='597' || product.product=='598' || product.product=='599' || product.product=='600' || product.product=='601' || product.product=='602' || product.product=='603' || product.product=='604' || product.product=='605' || product.product=='606' || product.product=='607' || product.product=='608' || product.product=='609' || product.product=='610' || product.product=='611' || product.product=='612' || product.product=='613' || product.product=='615' || product.product=='614' || product.product=='616' || product.product=='617' || product.product=='618' || product.product=='502' || product.product=='503' || product.product=='789' || product.product=='506')">
                  <label class="checkout-label">Número de banner</label>
                  <input class="form-control checkout-input" v-model="ticketsTable[index].ig" type="text" name="banner" placeholder="Número de banner" required="">
                </div>

                <div class="checkout-field checkout-field--full" v-if="event.id==181 && (product.product=='12923' || product.product=='586' || product.product=='587' || product.product=='588' || product.product=='589' || product.product=='590' || product.product=='591' || product.product=='592' || product.product=='593' || product.product=='594' || product.product=='595' || product.product=='596' || product.product=='597' || product.product=='598' || product.product=='599' || product.product=='600' || product.product=='601' || product.product=='602' || product.product=='603' || product.product=='604' || product.product=='605' || product.product=='606' || product.product=='607' || product.product=='608' || product.product=='609' || product.product=='610' || product.product=='611' || product.product=='612' || product.product=='613' || product.product=='615' || product.product=='614' || product.product=='616' || product.product=='617' || product.product=='618' || product.product=='502' || product.product=='503' || product.product=='789' || product.product=='506')">
                  <label class="checkout-label">Código de estudiante</label>
                  <input class="form-control checkout-input" v-model="ticketsTable[index].ig" type="text" name="student_code" placeholder="Código de estudiante" required="">
                </div>

                <div class="checkout-field" v-if="event.id==8">
                  <label class="checkout-label">Talla</label>
                  <select class="form-control checkout-input" v-model="ticketsTable[index].size" aria-label="Talla camiseta" required="">
                    <option value="" disabled selected>Talla camiseta</option>
                    <option value="XS/Extra Pequeño">XS/Extra Pequeño</option>
                    <option value="Small/Pequeño">Small/Pequeño</option>
                    <option value="Medium/Mediano">Medium/Mediano</option>
                    <option value="Large/Largo">Large/Largo</option>
                    <option value="XL/Extra Grande">XL/Extra Grande</option>
                  </select>
                </div>

                <div class="checkout-field" v-if="event.id==8">
                  <label class="checkout-label">Género</label>
                  <select class="form-control checkout-input" v-model="ticketsTable[index].gender" aria-label="Género" required="">
                    <option value="0" disabled selected>Género</option>
                    <option value="1">Masculino</option>
                    <option value="2">Femenino</option>
                    <option value="3">Otro</option>
                  </select>
                </div>

                <div v-for="(extra, extraIndex) in extraData" :key="extraIndex" class="checkout-field checkout-field--full">
                  <label class="checkout-label">Dato adicional</label>
                  <input class="form-control checkout-input" v-model="ticketsTable[extraIndex].last_name" type="text" :placeholder="extra.name" required="">
                </div>
              </div>
            </article>
          </div>

          <div v-if="!loadingUser" class="checkout-step__actions checkout-step__actions--dock">
            <div class="checkout-step__actions-copy">
              <span class="checkout-step__summary-label">Paso 2 listo</span>
              <small class="checkout-step__summary-note">{{ ticketsTable.length }} acceso(s) listos para continuar</small>
            </div>
            <button class="btn btn-primary btn-block checkout-step__button liquid-page-button" type="submit">
              <span class="liquid-page-button__glow"></span>
              <span class="liquid-page-button__ring"></span>
              <span class="liquid-page-button__inner">
                <span class="liquid-page-button__copy">Continuar</span>
              </span>
            </button>
          </div>

          <div v-if="loadingUser" class="d-flex justify-content-center checkout-step__loader">
            <scaling-squares-spinner :size="60" color="#bec7d2" />
          </div>
        </div>
      </form>
    </div>
  </section>
</template>


  


<script>
import { apiService } from "../../common/api.services.js";
import { ScalingSquaresSpinner   } from 'epic-spinners';


export default {
  
    name: 'GuestName',
    props:{
        productsProp: {
          type: Object
       },
       order_finalF: {
       },

        event: {
           type: Object
       },

       selectedSeats:{
         type: Array
       },

       seatsProducts:{
         type: Array
       }

       
     },


     components: {
    ScalingSquaresSpinner  ,
  },     

     data(){
      return{
        name: "",
        last_name: "",
        cc:"",
       events:[],
       next:null,
       ticketsTable:[],
       order:[],
       total: 0.00,
       fee: 0.00,
       email: "",
       phone: "",
        userSearched: false,
        password: "",
        loadingUser: false,
        loadingMain: false,
        term: "",
        address: "",
        require_account: false,
        customer: null,
        extraData: [],
        timer: null,
        looking: false,
        success: false,
        error: "",
        
      }
     

   },

    created () {
      this.createTable()
  },

  
   methods:{


    


   

    createTable() {


///fetch('https://api.ipify.org/?format=json')
///.then(function(response) {
  //response.json().then(jsonData => {
    //console.log("Llega a ip");

    //console.log(jsonData);
  //});
//})
//.catch(function(error) {
  //console.log("Error ip");
  //7console.log(error)
//});




//fetch('https://ipapi.co/' + this.term + '/json/')
//.then(function(response) {
  //response.json().then(jsonData => {

    //console.log("Llega a  geo");

    //console.log(jsonData);

  //this.city=jsonData.city
  //this.region=jsonData.region


  //});
//})
//.catch(function(error) {
  //console.log("Error geo");
  //console.log(error)
  //this.city=""
 //// this.region=""
//});
    for (var i = 0; i < this.productsProp.length; i++){      
      for (let index = 0; index < this.productsProp[i].quantity; index++) {

        for (let j = 0; j < this.productsProp[i].quantity_factor; j++) {
          
        let uProduct =  {quantity:1, amount: this.productsProp[i].amount, product: this.productsProp[i].id , name: this.productsProp[i].name, is_courtesy:  this.productsProp[i].is_courtesy, first_name: "",  last_name: "", payment_term: 1, ig: "", age: "", cc: "", size: "", gender: 0, entry: "", seat: ""};
        this.ticketsTable=this.ticketsTable.concat(uProduct)
       
      }
      }
      } 


      let numberF = 0

      for (i = 0; i < this.seatsProducts.length; i++){  

      for (let index = 0; index < this.seatsProducts[i].quantity; index++) {

        for (let j = 0; j < this.seatsProducts[i].quantity_factor; j++) {
         
            let uProduct =  {quantity:1, amount: this.seatsProducts[i].amount, product: this.seatsProducts[i].id , name: this.seatsProducts[i].name, is_courtesy:  this.seatsProducts[i].is_courtesy, first_name: "",  last_name: "", payment_term: 1, ig: "", age: "", cc: "", size: "", gender: 0, entry: "", seat: this.selectedSeats[numberF].id, seat_name: this.selectedSeats[numberF].name, seat_assigned: true};
             this.ticketsTable=this.ticketsTable.concat(uProduct)
             numberF++
       
      }
      }
      } 



      








      if (this.event.quick_checkout_enabled){
        this.customer=1
        this.$emit('messageFromGuestName', this.ticketsTable, this.customer)
      }
    },


      getCustomer(){



        this.userSearched=false
      let endpoint = `/api/contacts/?email=${this.email}`; //open pos


      console.log(endpoint)

        clearTimeout(this.timer)

        this.timer = setTimeout(() => {
                
      apiService(endpoint).then(data => {
        if (data.length==0){
          this.require_account=true
          this.userSearched=true

        
        }else{
          this.customer = data[0];
          this.require_account=false
          this.userSearched=true

        }
        this.looking=false

      });
    
    }, 1250)
  },



  continueSale(){

     if (this.userSearched){
      this.loadingUser=true

      
      if(this.require_account==false){
      this.$emit('messageFromGuestName', this.ticketsTable, this.customer)
      }else{
        this.createCustomer()
      }
  }
    },


 createCustomer(){
    let first_name=this.ticketsTable[0].first_name
    let last_name=this.ticketsTable[0].last_name
    this.loadingMain=true
    this.success = false
    var profile = new Object();
    profile.phone =  this.phone
    profile.address = this.address
    profile.city = ""
    if (this.password==""){
      this.password="fomoplankk9876"

    }
    if(this.email!=""){
        let endpoint =  `/api/user/create`
       
    apiService(endpoint, "POST", {
  
    password: this.password,
    contact_profile: profile,
    first_name: first_name,
    last_name: last_name,
    email: this.email,
    username: this.email

  })
              .then(data => {
                  if (data.id){
                    this.customer=data
                    console.log(data)
                    this.require_account=false

                   this.continueSale()
        
                  }else{

                      alert("Error al crear la cuenta. Revisa los datos e inténtalo nuevamente.")
                      this.error="Verifique que los datos sean correctos"
                      this.loadingUser=false

                  }

        
               
              })

              

    

      }else {
        this.error="Llene todos los campos"
      }
    },


    


    openEvent(_id) {
      this.$router.push({ name: "event", params: { id: _id } });
    },


    increment (quantity, i) {
      this.availableTickets[i].quantity++
      this.availableTickets[i].total= (this.availableTickets[i].quantity * this.availableTickets[i].amount).toFixed(2)
       this.availableTickets[i].amount=this.availableTickets[i].amount*1
      this.total=this.total + this.availableTickets[i].amount
      this.total.toFixed(2)
    },
    decrement (quantity, i) {
      if(quantity === 0) {
         this.availableTickets[i].quantity=0
           }else{

     
        this.availableTickets[i].quantity--
      this.availableTickets[i].total= (this.availableTickets[i].quantity * this.availableTickets[i].amount).toFixed(2)
       this.availableTickets[i].amount=this.availableTickets[i].amount*1
      this.total=this.total - this.availableTickets[i].amount
      this.total.toFixed(2)
       }
    
      
    }

    
   }
}
</script>

<style>

#imagemPosterSlide{
  padding: 10px;
  
}

.container{
  justify-content:center
}


  
</style>



<style lang="css">
h1 {
  text-align: center;
  margin-bottom: 50px;
  margin-top: 50px;
}

.blog-card-blog {
  margin-top: 30px;
}

.blog-card {
  display: inline-block;
  position: relative;
  width: 100%;
  margin-bottom: 30px;
  border-radius: 6px;
  color: rgba(0, 0, 0, 0.87);
  background: rgb(52, 58, 64);
  background-color: rgb(52, 58, 64);
}



.blog-card .blog-table {
  padding: 15px 30px;
}

.blog-table {
  margin-bottom: 0px;
}

.blog-category {
  position: relative;
  line-height: 0;
  margin: 15px 0;
}

.blog-text-success {
  color: rgb(198,197,197);
}

.blog-card-blog .blog-card-caption {
  margin-top: 5px;
}

.blog-card-caption {
  font-weight: 700;
  font-family: "Roboto Slab", "Times New Roman", serif;
}

.blog-card-caption, .blog-card-caption a {
  color: #333;
  text-decoration: none;
}

p {
  color: #3C4857;
  margin-top: 0;
  margin-bottom: 1rem;
}

.blog-card .ftr {
  margin-top: 15px;
}

.blog-card .ftr .author {
  color: #888;
}

.blog-card .ftr div {
  display: inline-block;
}

.blog-card .author .avatar {
  width: 36px;
  height: 36px;
  overflow: hidden;
  border-radius: 50%;
  margin-right: 5px;
}

.blog-card .ftr .stats {
  position: relative;
  top: 1px;
  font-size: 14px;
}

.blog-card .ftr .stats {
  float: right;
  line-height: 30px;
}

a {
  text-decoration: none;
}


 .d-inline .input {
    border: 0;
    width: 2.5rem;
    text-align: center;
    padding: 0 .5rem;
  }

.quantity-toggle .button {
    background: rgb(198,197,197);
    font-size: 1rem;
    cursor: pointer;
    color: white;
  }


.cont{
   padding-right: 50px;
   padding-left: 50px;
}
.rw{
   padding-right: 5px;
   padding-left: 5px;
  border-top: 1px solid white;



}

@media (max-width: 768px) {
.cont {
    padding-left: 10px;
    padding-right: 10px;
}

.rw{
   padding-right: 10px;
   padding-left: 10px;


}
}


    
</style>

   
